import { themeStyle } from '@repo/ui/theming';

export const buttonTheme = {
  color: themeStyle.varInkMain,
  spinnerColor: themeStyle.varInkMain,
  activeColor: themeStyle.varInkMain,

  backgroundColor: themeStyle.varInkSuperLight,
  borderColor: themeStyle.varInkSuperLight,
  backgroundActiveColor: themeStyle.varInkLight,
  borderActiveColor: themeStyle.varInkLight,

  fontWeight: themeStyle.fontMedium,
  fontWeightActive: themeStyle.fontSemiBold,

  backgroundColorDark: null,
  borderColorDark: null,
  backgroundActiveColorDark: null,
  borderActiveColorDark: null,
};
